<template>
  <Layout >
    <div>
      <!--<img class="h-full w-full pt-1" src="../assets/RasFamilie.png" alt="Workflow" />-->
    <div  class="flex items-center justify-center pt-5 ">
  <div v-if="mobileOpen" class="max-w-full w-full text-lg sm:text-2xl md:text-xl lg:text-xl">
    <div>
      <img class="mx-auto h-40 w-auto rounded-full" src="../assets/gracefinal.png" alt="Workflow" />
    </div>
    {{errorMessage}}
    <div class="text-xl text-left text-black">
    <p v-if="errors.length">
      <b>Please Fill in all the Details:</b>
      <ul>
        <div class="text-red-600 text-left">
        <li v-for="error in errors" :key=error>{{ error }}</li>
        </div>
      </ul>
    </p>
    </div>
    <div v-if="mobileOpen">
    <BaseInput class="text-center align-center" label="" placeholder="Email Address..." v-model="email" />
    <BaseInput label="" placeholder="Password..." input type="password" v-model="password" />
    <div class="pb-4"></div>
    <div id="app" v-cloak>
    <div class="text-red-500 text-center text-xl pb-4">
    <BaseButton v-on:click="checkForm(); login(); " >LOGIN</BaseButton>
   </div>
    <div class="pb-2"></div>
   <!-- <BaseButton v-on:click="toggleMobilemenu2(); toggleMobilemenu(); " >REGISTER HERE</BaseButton>-->
  </div>
    </div>
    <div v-if="mobileOpen1" class="max-w-full w-full text-lg sm:text-2xl md:text-xl lg:text-xl">
    <h2 
      class="text-3xl ptracking-tight leading-10 font-extrabold text-black-900 sm:text-3xl sm:leading-none sm:text-left md:text-4xl sm:justify-start lg:text-center md:text-center"
        >
      Register <b  class="text-blue-900">here</b>
    </h2> 
    <BaseInput label="" placeholder="Company..." v-model="company" />
    <BaseInput label="" placeholder="Name.." v-model="name" />
    <BaseInput label="" placeholder="Contact Number..." input type="number" v-model="contact" />
    <BaseInput label="" placeholder="Email Address..." v-model="email" />
    <BaseInput label="" placeholder="Password..." input type="password" v-model="password" />
    <BaseInput label="" placeholder="Re-Enter Password..." input type="password" v-model="checkPassword" />
    <div id="app" v-cloak>
    <div class="password">
    <input :class='{valid:passwordValidation.valid}' :type="passwordVisible ? 'text' : 'password'" hidden v-model="password">
    </div>
    <input type="password" hidden v-model.lazy='checkPassword'>

    <transition name="hint" appear>
      <div v-if='passwordValidation.errors.length > 0 && !submitted' class='hints'>
        <h2>Hints</h2>
        <p v-for="error in passwordValidation.errors" :key=error>{{error}}</p>
      </div>
    </transition>
    <div class="matches" v-if='notSamePasswords'>
      <p class="text-red-600">Passwords don't match.</p>
    </div>
    <div class="text-red-500 text-center text-xl pb-2">
      <BaseButton v-on:click="checkForm1(); registerUser(); toggleMobilemenu1(); toggleMobilemenu();" v-if='passwordsFilled && !notSamePasswords && passwordValidation.valid' >Register Now</BaseButton>
    </div>
  <br>
</div>
    </div>
    <br>
  
    
  </div>
  <div v-if="mobileOpen2" class="max-w-full w-full text-lg sm:text-2xl md:text-xl lg:text-xl">
    <div>
      <img @click="toggleMobilemenu2(); toggleMobilemenu();" class="mx-auto h-40 w-auto rounded-lg" src="../assets/grace.png" alt="Workflow" />
    </div>
    {{errorMessage}}
    <div class="text-xl text-left text-black">
    <p v-if="errors.length">
      <b>Please Fill in all the Details:</b>
      <ul>
        <div class="text-red-600 text-left">
        <li v-for="error in errors" :key=error>{{ error }}</li>
        </div>
      </ul>
    </p>
    </div>
    <div>
    <h2 
      class="text-3xl ptracking-tight leading-10 font-extrabold text-black-900 sm:text-3xl sm:leading-none sm:text-left md:text-4xl sm:justify-start lg:text-center md:text-center"
        >
      Register <b style="color: #815433" class="text-blue-900">here</b>
    </h2> 
    <!--<BaseInput label="" placeholder="Company..." v-model="company" />-->
    <BaseInput label="" maxlength="25" placeholder="Name.." v-model="name" />
    <!--<BaseInput label="" placeholder="Contact Number..." input type="number" v-model="contact" />-->
    <BaseInput label="" placeholder="Email Address..." v-model="email" />
    <BaseInput label="" placeholder="Password..." input type="password" v-model="password" />
    <BaseInput label="" placeholder="Re-Enter Password..." input type="password" v-model="checkPassword" />
    <div id="app" v-cloak>
    <div class="password">
    <input :class='{valid:passwordValidation.valid}' :type="passwordVisible ? 'text' : 'password'" hidden v-model="password">
    </div>
    <input type="password" hidden v-model.lazy='checkPassword'>

    <transition name="hint" appear>
      <div v-if='passwordValidation.errors.length > 0 && !submitted' class='hints'>
        <h2>Hints</h2>
        <p v-for="error in passwordValidation.errors" :key=error>{{error}}</p>
      </div>
    </transition>
    <div class="matches" v-if='notSamePasswords'>
      <p class="text-red-600">Passwords don't match.</p>
    </div>
    <div class="text-red-500 text-center text-xl pb-2">
      <BaseButton v-on:click="checkForm1(); registerUser(); " v-if='passwordsFilled && !notSamePasswords && passwordValidation.valid' >Register Now</BaseButton>
     
    </div>
  <br>
</div>
    </div>
    <br>
  
    
  </div>
</div>
  <div >
    
    </div>
  </div>

  </Layout>
</template>

<script>
import Layout from './layouts/Main'
import firebase from 'firebase/app';
import { mapGetters } from "vuex";
//import firebase from 'firebase/app';
import "firebase/auth";
import firebaseCredentials from "../firebase-credentials.json";
//import * as firebaseui from 'firebaseui'
//import 'firebaseui/dist/firebaseui.css'
import { mapActions } from 'vuex'
import BaseInput from "../components/BaseInput";
import BaseButton from "../components/BaseButton";
import 'firebaseui/dist/firebaseui.css'

const firebaseInstanceCopy = firebase.initializeApp(firebaseCredentials, "firebaseInstanceCopy");

export default {
  name: 'userlogin',
  components: { Layout, BaseInput, BaseButton },
  data() {
    return {
      rules: [
				{ message:'One lowercase letter required.', regex:/[a-z]+/ },
				{ message:"One uppercase letter required.",  regex:/[A-Z]+/ },
				{ message:"8 characters minimum.", regex:/.{8,}/ },
				{ message:"One number required.", regex:/[0-9]+/ }
			],
      pages: {},
      errors: [],
      passwordVisible:false,
			submitted:false,
      contact : "",
      company: "",
      user: "",
      name: "",
      email: "",
      passcode: "",
      mobileOpen: true,
      mobileOpen1: false,
      mobileOpen2: false,
      password : "",
      checkPassword: "",
      startDate: Date.now(),
      //hello: "",
      //submitted:false,
      
    };
  },
  created(){
    this.userData = this.currentUserData;
    this.getPages();
    if(this.currentUserData.onboardingComplete === true)
  {
    this.redirect('dashboard')
  }
    
  },
  mounted() {
    this.getPages();
  
  },
  methods: {
    ...mapActions(['setCurrentUser', 
    "isLoggedIn"]
    ),
    getPages() {
      //const employer = [];
      const employerData = this.$db
        .collection("websitestatus")
        .where("status", "==", "active");

      employerData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.pages = data;
        });
      });
    },
    toggleMobilemenu() {
      this.mobileOpen = !this.mobileOpen;
    },
    toggleMobilemenu1() {
      this.mobileOpen1 = !this.mobileOpen1;
    },
    toggleMobilemenu2() {
      this.mobileOpen2 = !this.mobileOpen2;
    },
    login(){
        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          alert('successfully logged in');
          this.$router.push({
              name: 'dashboard',
              
            })
          })
          .catch((err) => {
            console.log(err)
            alert("Incorrect Username/Password or not Registered")
            //window.confirm("Incorrect Username/Password or not Registered.");
          })
        //window.confirm("Incorrect Username/Password or not Registered.");
        
      
    },
    trigger: function() {
      this.error = true
      this.errorMessage = "Whoops!"
    },
    setTab(tab) {
      this.tab = tab;
    },
    registerUserOld(){
        firebaseInstanceCopy.auth().createUserWithEmailAndPassword(this.email, this.password)
        .then((result) => {
            this.$db
            .collection("users")
            .doc(result.user.uid)
            .set({
                onboardingComplete: true,
                contactNumber: this.contact,
                email: this.email,
                name: this.name,
                userType: "user",
                status: "approved",
                MainAdmin: "no",
                timestamp: Date.now(),
                
            }),
            firebaseInstanceCopy.auth().signOut();
            //window.confirm("User Account was Added.");
        //console.log(result);
            }).catch((err) => {
            console.log(err)
            //window.confirm("Incorrect Username/Password or not Registered.");
            })
            window.confirm("User Account was Added.");
            this.$router.push({
              name: 'dashboard',
              
            })
            
        //this.resetPasswords();
        //this.$router.go(0)

    },
    registerUser(){
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
        .then((result) => {
            this.$db
            .collection("users")
            .doc(result.user.uid)
            .set({
                onboardingComplete: true,
                //contactNumber: this.contactNumber,
                email: this.email,
                name: this.name,
                timestamp: Date.now(),
                startDate: new Date(this.startDate).toLocaleDateString(),
                userType: "Registering",
                status : 'inactive'
                  
                
            }),
            firebase.auth().signin();
            window.confirm("User Account was Added.");
            this.$router.push({
            name: "dashboard",
            });
        //console.log(result);
            }).catch((err) => {
            console.log(err)
            })
            window.confirm("User Account was Added.");
            this.$router.push({
            name: "dashboard",
            });
            //window.confirm("User Account was Added.");
           
        //this.resetPasswords();
        //this.$router.go(0)

    },
    redirect() {
      this.$router.push({
      name: "dashboard",
      });
    },
    Register() {
      this.$router.push({
      name: "register",
      });
    },
    checkForm: function (e) {
      this.errors = [];

        if (!this.email) {
          this.errors.push("Email is required...");
        }
        if (!this.password) {
          this.errors.push("password is required...");
        }
        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },

      checkForm1: function (e) {
      this.errors = [];

       
        if (!this.name) {
          this.errors.push("Name is required...");
        }
       
        if (!this.email) {
          this.errors.push("Email is required...");
        }
        if (!this.email) {
          this.errors.push('Email is required...');
        } else if (!this.validEmail(this.email)) {
          this.errors.push('A Valid Email address is required.');
        }
        if (!this.password) {
          this.errors.push("Password is required...");
        }
        if (!this.errors.length) {
          return true;
        }
        e.preventDefault();
      },
      validEmail: function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },    
       
  },
  computed: {
    ...mapGetters(["isLoggedIn", "currentUserData"]),

      notSamePasswords () {
          if (this.passwordsFilled) {
            return (this.password !== this.checkPassword)
          } else {
            return false
          }
        },
      passwordsFilled () {
        return (this.password !== '' && this.checkPassword !== '')
      },
      passwordValidation () {
        let errors = []
        for (let condition of this.rules) {
          if (!condition.regex.test(this.password)) {
            errors.push(condition.message)
          }
        }
        if (errors.length === 0) {
          return { valid:true, errors }
        } else {
          return { valid:false, errors }
        }
      },
  },
}
</script>
